import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchDivisions } from "reduxStore/actions/divisionActions";

function ReassignDepartmentDialog({
  open,
  handleClose,
  handleReassignConfirm,
}) {
  const dispatch = useDispatch();
  const divisions = useSelector((state) => state.divisions.data || []);
  const [selectedDivision, setSelectedDivision] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(fetchDivisions({ page: 0, limit: 100, sort: "", search: "" })); // Load all divisions
    }
  }, [open, dispatch]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Reassign Assessments</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel>Select New Department</InputLabel>
          <Select
            value={selectedDivision}
            onChange={(e) => setSelectedDivision(e.target.value)}
          >
            {divisions.map((division) => (
              <MenuItem key={division._id} value={division._id}>
                {division.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={() => handleReassignConfirm(selectedDivision)}
          color="primary"
          disabled={!selectedDivision}
        >
          Reassign & Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReassignDepartmentDialog;
